import { useMemo, useState } from "react";
import { dashboardService } from "@/api/services/dashboardService";
import type { RegisterCustomerVo } from "@/entity/dashboard";
import { getLastYearMonths } from "@/utils";
import DashboardChart from "../chart";
import { getTtackBarOption } from "../chartDefaultOption";
import {
    DashboardDateSelect,
    type DashboardDateValue,
    DataWrap,
    toDashboardAnalysisParams,
    useDashboardQuery
} from "../dashboardWidgets";

/** 新增注册用户分析，复用旧 Vue 的 ECharts 坐标轴、柱形和汇总提示。 */
export default function AddRegisteredCustomerAnalysis() {
    const [time, setTime] = useState<DashboardDateValue>(3);
    const { data } = useDashboardQuery<RegisterCustomerVo>(
        () => dashboardService.getAddRegisteredCustomerAnalysis(toDashboardAnalysisParams(time)),
        [time]
    );
    const customerValues = data?.addRegisterCustomerNums || [];
    const carrierValues = data?.addRegisterCarrierNums || [];
    const total = [...customerValues, ...carrierValues].reduce((sum, value) => sum + Number(value || 0), 0);
    const xAxisData = useMemo(() => {
        if (typeof time === "string") return Array.from({ length: 12 }, (_, index) => `${index + 1}月`);
        return getLastYearMonths(time === 4 ? 12 : 3);
    }, [time]);
    const option = useMemo(
        () =>
            getTtackBarOption({
                titleText: "人数",
                series: [
                    {
                        data: customerValues,
                        type: "bar",
                        stack: "链云",
                        barWidth: 14,
                        itemStyle: { color: "#1777ff" }
                    }
                ],
                xAxisData,
                barBorderRadius: 4,
                grid: { left: "1%", right: "4%", bottom: "0%", containLabel: true }
            }),
        [customerValues, xAxisData]
    );

    return (
        <DataWrap
            title="注册用户新增分析"
            className="add-registered-customer-analysis"
            option={
                <DashboardDateSelect
                    value={time}
                    onChange={setTime}
                    options={["quarter", "year"]}
                    defaultActive="quarter"
                    pickerType="year"
                />
            }
        >
            <div className="dashboard-analysis-main">
                <DashboardChart option={option} />
                <div className="dashboard-analysis-tip">新增注册用户 {total.toLocaleString("zh-CN")}人</div>
            </div>
        </DataWrap>
    );
}
